import * as customer from '../modules/customer';
import * as apigee from '../modules/apigee';
import { apigee as apigeeSecret } from '../settings/secrets.json';

const init = {
    isLoading: false,
    isValid: null,
    isDirty: false,
    isAuthenticated: false,
    accessCode: null,
    lastName: null,
    hasError: false,
    errorCode: null,
    errorText: null,
    submittedAnswersCounter: 0
};

function customerReducer(state = init, action) {
    let newState = Object.assign({}, state);

    if (action.type === 'REQUEST_ACCESS_TOKEN') {
        const { env, accessCode, lastName, isDirty } = action.data;

        if (!state.isLoading) {
            apigee.getAccessToken(env, { accessCode, lastName }, apigeeSecret[env]);
        }

        newState = {
            ...state,
            isDirty,
            error: false,
            id: null,
            isValid: null,
            hasError: false,
            policyNumber: null,
            isLoading: true,
            questions: []
        };
    }

    if (action.type === 'RECEIVE_ACCESS_TOKEN') {
        const { isValid, ...rest } = action.data;
        //for some reason, we can't destruct lastName and accessCOde from action.data so we have to do the following hack:
        delete rest.accessCode;
        delete rest.lastName;
        delete rest.isValid;

        newState = {
            ...state,
            apigee: rest,
            lastName: action.data.lastName,
            accessCode: action.data.accessCode,
            isValid: JSON.parse(isValid),
            isDirty: false,
            isLoading: false
        };
    }

    if (action.type === 'APIGEE_OAUTH_CALL_FAILURE') {
        newState = {
            ...state,
            isLoading: false,
            isDirty: false,
            hasError: true,
            error: action.data.message
        };
    }

    if (action.type === 'REQUEST_SECURITY_QUESTIONS') {
        const {
            env,
            accessCode,
            lastName,
            apigee: { jwtToken }
        } = action.data;

        const accessToken = state.apigee.access_token;

        const isDirty =
            (state.accessCode !== null || state.lastName !== null) &&
            (state.accessCode !== accessCode || state.lastName !== lastName);

        if (state.isValid || !isDirty) {
            customer.securityQuestions({ accessCode, lastName }, { env, jwtToken, accessToken });
        }

        newState = {
            ...state,
            isLoading: true
        };
    }

    if (action.type === 'RECEIVE_SECURITY_QUESTIONS') {
        const { questions, policyNumber, isLocked, lastFailedAttemptTimeStamp } = action.data;

        const orderedQuestions = questions.sort((a, b) => {
            if (a.rank < b.rank) return -1;
            if (a.rank > b.rank) return 1;
            return 0;
        });

        const filteredQuestions = orderedQuestions.filter(q => !q.asked);

        // make sure there is no leading or trailing spaces on options
        filteredQuestions.forEach(function(q) {
            q.options.forEach(function(option, i, options) {
                options[i] = option.trim();
            });
        });

        newState = {
            ...state,
            isLocked,
            lastFailedAttemptTimeStamp,
            policyNumber,
            questions: filteredQuestions,
            isLoading: false
        };
    }

    if (action.type === 'REQUEST_SECURITY_QUESTIONS_VALIDATION') {
        const accessToken = state.apigee.access_token;
        const { data, tokens } = action.data;

        customer.validateSecurityQuestionAnswer(data, { ...tokens, accessToken });

        newState = {
            ...state,
            submittedAnswersCounter: state.submittedAnswersCounter + 1,
            isLoading: true
        };
    }

    if (action.type === 'RECEIVE_SECURITY_QUESTIONS_VALIDATION') {
        const {
            isAnsweredCorrectly,
            questionID,
            isLocked,
            lastFailedAttemptTimeStamp
        } = action.data;

        //check for at least one correct answer to set isAuthenticated to true
        const questions = state.questions.map(q => {
            if (q.id === questionID) {
                q.isAnsweredCorrectly = isAnsweredCorrectly;
            }
            return q;
        });

        const isAuthenticated = questions.some(q => q.isAnsweredCorrectly);

        newState = {
            ...state,
            questions,
            lastFailedAttemptTimeStamp,
            isAuthenticated,
            isLocked,
            isLoading: false
        };
    }

    if (action.type === 'CALL_FAILURE') {
        newState = {
            ...state,
            isLoading: false,
            hasError: true,
            errorCode: action.data.status,
            errorText: action.data.statusText
        };
    }

    return newState;
}

export default customerReducer;



// WEBPACK FOOTER //
// ./src/reducers/customer.js